import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const Inbox = () => {
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null); // Untuk menyimpan pesanan yang diklik
    const [isModalOpen, setIsModalOpen] = useState(false); // State untuk modal

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const userId = user.uid;
                const db = getDatabase();
                const ordersRef = ref(db, `orders/${userId}`);

                // Mengambil data pesanan dari Firebase
                const unsubscribeOrders = onValue(ordersRef, (snapshot) => {
                    const data = snapshot.val();
                    if (data) {
                        const formattedOrders = Object.entries(data).map(
                            ([orderId, orderData]) => ({
                                id: orderId,
                                ...orderData
                            })
                        );
                        setOrders(formattedOrders);
                    } else {
                        setOrders([]);
                    }
                });

                return () => unsubscribeOrders(); // Hapus listener saat komponen tidak digunakan
            }
        });

        return () => unsubscribe(); // Hapus listener autentikasi saat komponen tidak digunakan
    }, []);

    // Fungsi untuk membuka modal
    const openModal = (order) => {
        setSelectedOrder(order);
        setIsModalOpen(true);
    };

    // Fungsi untuk menutup modal
    const closeModal = () => {
        setSelectedOrder(null);
        setIsModalOpen(false);
    };

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-3xl font-bold mb-4">Pesanan Anda</h1>
            {orders.length === 0 ? (
                <p>Tidak ada pesanan.</p>
            ) : (
                <div className="grid grid-cols-1 gap-6">
                    {orders.map((order) => (
                        <div
                            key={order.id}
                            className="p-4 border rounded-lg bg-white shadow-md cursor-pointer"
                            onClick={() => openModal(order)} // Klik untuk membuka modal
                        >
                            <h2 className="text-xl font-bold mb-2">
                                Pesanan ID: {order.id}
                            </h2>
                            <p className="text-gray-600 mb-2">
                                Tanggal:{" "}
                                {new Date(order.date).toLocaleString("id-ID")}
                            </p>
                            <p className="text-gray-800 font-semibold">
                                Total Harga: Rp{" "}
                                {order.totalPrice.toLocaleString("id-ID")}
                            </p>
                        </div>
                    ))}
                </div>
            )}

            {/* Modal untuk menampilkan pesan admin */}
            {isModalOpen && selectedOrder && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-11/12 md:w-2/3 lg:w-1/2">
                        <h2 className="text-2xl font-bold mb-4">
                            Pesanan ID: {selectedOrder.id}
                        </h2>
                        <p className="text-gray-600 mb-2">
                            Tanggal:{" "}
                            {new Date(selectedOrder.date).toLocaleString(
                                "id-ID"
                            )}
                        </p>
                        <p className="text-gray-800 font-semibold mb-2">
                            Total Harga: Rp{" "}
                            {selectedOrder.totalPrice.toLocaleString("id-ID")}
                        </p>
                        <h3 className="text-lg font-bold mb-2">Pesan Admin:</h3>
                        <p className="text-gray-700 mb-6">
                            {/* Pesan admin diambil dari data pesanan */}
                            {selectedOrder.items
                                ? selectedOrder.items
                                      .map(
                                          (item) =>
                                              `${
                                                  item.adminMessage ||
                                                  "Belum ada pesan."
                                              }`
                                      )
                                      .join("\n")
                                : "Belum ada pesan dari admin."}
                        </p>
                        <div className="flex justify-end">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Inbox;
